import { t } from 'i18n'
import getMetaValue from './getMetaValue'

export const languages = getMetaValue('languages').split(',')

export const ALL_LANGUAGES = [
  { code: 'ab', name: t('languages.ab') },
  { code: 'aa', name: t('languages.aa') },
  { code: 'af', name: t('languages.af') },
  { code: 'ak', name: t('languages.ak') },
  { code: 'sq', name: t('languages.sq') },
  { code: 'am', name: t('languages.am') },
  { code: 'ar', name: t('languages.ar') },
  { code: 'an', name: t('languages.an') },
  { code: 'hy', name: t('languages.hy') },
  { code: 'as', name: t('languages.as') },
  { code: 'av', name: t('languages.av') },
  { code: 'ae', name: t('languages.ae') },
  { code: 'ay', name: t('languages.ay') },
  { code: 'az', name: t('languages.az') },
  { code: 'bm', name: t('languages.bm') },
  { code: 'ba', name: t('languages.ba') },
  { code: 'eu', name: t('languages.eu') },
  { code: 'be', name: t('languages.be') },
  { code: 'bn', name: t('languages.bn') },
  { code: 'bh', name: t('languages.bh') },
  { code: 'bi', name: t('languages.bi') },
  { code: 'bs', name: t('languages.bs') },
  { code: 'br', name: t('languages.br') },
  { code: 'bg', name: t('languages.bg') },
  { code: 'my', name: t('languages.my') },
  { code: 'ca', name: t('languages.ca') },
  { code: 'ch', name: t('languages.ch') },
  { code: 'ce', name: t('languages.ce') },
  { code: 'ny', name: t('languages.ny') },
  { code: 'zh', name: t('languages.zh') },
  { code: 'cv', name: t('languages.cv') },
  { code: 'kw', name: t('languages.kw') },
  { code: 'co', name: t('languages.co') },
  { code: 'cr', name: t('languages.cr') },
  { code: 'hr', name: t('languages.hr') },
  { code: 'cs', name: t('languages.cs') },
  { code: 'da', name: t('languages.da') },
  { code: 'dv', name: t('languages.dv') },
  { code: 'nl', name: t('languages.nl') },
  { code: 'dz', name: t('languages.dz') },
  { code: 'en', name: t('languages.en') },
  { code: 'eo', name: t('languages.eo') },
  { code: 'et', name: t('languages.et') },
  { code: 'ee', name: t('languages.ee') },
  { code: 'fo', name: t('languages.fo') },
  { code: 'fj', name: t('languages.fj') },
  { code: 'fi', name: t('languages.fi') },
  { code: 'fr', name: t('languages.fr') },
  { code: 'ff', name: t('languages.ff') },
  { code: 'gl', name: t('languages.gl') },
  { code: 'ka', name: t('languages.ka') },
  { code: 'de', name: t('languages.de') },
  { code: 'el', name: t('languages.el') },
  { code: 'gn', name: t('languages.gn') },
  { code: 'gu', name: t('languages.gu') },
  { code: 'ht', name: t('languages.ht') },
  { code: 'ha', name: t('languages.ha') },
  { code: 'he', name: t('languages.he') },
  { code: 'hz', name: t('languages.hz') },
  { code: 'hi', name: t('languages.hi') },
  { code: 'ho', name: t('languages.ho') },
  { code: 'hu', name: t('languages.hu') },
  { code: 'ia', name: t('languages.ia') },
  { code: 'id', name: t('languages.id') },
  { code: 'ie', name: t('languages.ie') },
  { code: 'ga', name: t('languages.ga') },
  { code: 'ig', name: t('languages.ig') },
  { code: 'ik', name: t('languages.ik') },
  { code: 'io', name: t('languages.io') },
  { code: 'is', name: t('languages.is') },
  { code: 'it', name: t('languages.it') },
  { code: 'iu', name: t('languages.iu') },
  { code: 'ja', name: t('languages.ja') },
  { code: 'jv', name: t('languages.jv') },
  { code: 'kl', name: t('languages.kl') },
  { code: 'kn', name: t('languages.kn') },
  { code: 'kr', name: t('languages.kr') },
  { code: 'ks', name: t('languages.ks') },
  { code: 'kk', name: t('languages.kk') },
  { code: 'km', name: t('languages.km') },
  { code: 'ki', name: t('languages.ki') },
  { code: 'rw', name: t('languages.rw') },
  { code: 'ky', name: t('languages.ky') },
  { code: 'kv', name: t('languages.kv') },
  { code: 'kg', name: t('languages.kg') },
  { code: 'ko', name: t('languages.ko') },
  { code: 'ku', name: t('languages.ku') },
  { code: 'kj', name: t('languages.kj') },
  { code: 'la', name: t('languages.la') },
  { code: 'lb', name: t('languages.lb') },
  { code: 'lg', name: t('languages.lg') },
  { code: 'li', name: t('languages.li') },
  { code: 'ln', name: t('languages.ln') },
  { code: 'lo', name: t('languages.lo') },
  { code: 'lt', name: t('languages.lt') },
  { code: 'lu', name: t('languages.lu') },
  { code: 'lv', name: t('languages.lv') },
  { code: 'gv', name: t('languages.gv') },
  { code: 'mk', name: t('languages.mk') },
  { code: 'mg', name: t('languages.mg') },
  { code: 'ms', name: t('languages.ms') },
  { code: 'ml', name: t('languages.ml') },
  { code: 'mt', name: t('languages.mt') },
  { code: 'mi', name: t('languages.mi') },
  { code: 'mr', name: t('languages.mr') },
  { code: 'mh', name: t('languages.mh') },
  { code: 'mn', name: t('languages.mn') },
  { code: 'na', name: t('languages.na') },
  { code: 'nv', name: t('languages.nv') },
  { code: 'nd', name: t('languages.nd') },
  { code: 'ne', name: t('languages.ne') },
  { code: 'ng', name: t('languages.ng') },
  { code: 'nb', name: t('languages.nb') },
  { code: 'nn', name: t('languages.nn') },
  { code: 'no', name: t('languages.no') },
  { code: 'ii', name: t('languages.ii') },
  { code: 'nr', name: t('languages.nr') },
  { code: 'oc', name: t('languages.oc') },
  { code: 'oj', name: t('languages.oj') },
  { code: 'cu', name: t('languages.cu') },
  { code: 'om', name: t('languages.om') },
  { code: 'or', name: t('languages.or') },
  { code: 'os', name: t('languages.os') },
  { code: 'pa', name: t('languages.pa') },
  { code: 'pi', name: t('languages.pi') },
  { code: 'fa', name: t('languages.fa') },
  { code: 'pl', name: t('languages.pl') },
  { code: 'ps', name: t('languages.ps') },
  { code: 'pt', name: t('languages.pt') },
  { code: 'qu', name: t('languages.qu') },
  { code: 'rm', name: t('languages.rm') },
  { code: 'rn', name: t('languages.rn') },
  { code: 'ro', name: t('languages.ro') },
  { code: 'ru', name: t('languages.ru') },
  { code: 'sa', name: t('languages.sa') },
  { code: 'sc', name: t('languages.sc') },
  { code: 'sd', name: t('languages.sd') },
  { code: 'se', name: t('languages.se') },
  { code: 'sm', name: t('languages.sm') },
  { code: 'sg', name: t('languages.sg') },
  { code: 'sr', name: t('languages.sr') },
  { code: 'gd', name: t('languages.gd') },
  { code: 'sn', name: t('languages.sn') },
  { code: 'si', name: t('languages.si') },
  { code: 'sk', name: t('languages.sk') },
  { code: 'sl', name: t('languages.sl') },
  { code: 'so', name: t('languages.so') },
  { code: 'st', name: t('languages.st') },
  { code: 'es', name: t('languages.es') },
  { code: 'su', name: t('languages.su') },
  { code: 'sw', name: t('languages.sw') },
  { code: 'ss', name: t('languages.ss') },
  { code: 'sv', name: t('languages.sv') },
  { code: 'ta', name: t('languages.ta') },
  { code: 'te', name: t('languages.te') },
  { code: 'tg', name: t('languages.tg') },
  { code: 'th', name: t('languages.th') },
  { code: 'ti', name: t('languages.ti') },
  { code: 'bo', name: t('languages.bo') },
  { code: 'tk', name: t('languages.tk') },
  { code: 'tl', name: t('languages.tl') },
  { code: 'tn', name: t('languages.tn') },
  { code: 'to', name: t('languages.to') },
  { code: 'tr', name: t('languages.tr') },
  { code: 'ts', name: t('languages.ts') },
  { code: 'tt', name: t('languages.tt') },
  { code: 'tw', name: t('languages.tw') },
  { code: 'ty', name: t('languages.ty') },
  { code: 'ug', name: t('languages.ug') },
  { code: 'uk', name: t('languages.uk') },
  { code: 'ur', name: t('languages.ur') },
  { code: 'uz', name: t('languages.uz') },
  { code: 've', name: t('languages.ve') },
  { code: 'vi', name: t('languages.vi') },
  { code: 'vo', name: t('languages.vo') },
  { code: 'wa', name: t('languages.wa') },
  { code: 'cy', name: t('languages.cy') },
  { code: 'wo', name: t('languages.wo') },
  { code: 'fy', name: t('languages.fy') },
  { code: 'xh', name: t('languages.xh') },
  { code: 'yi', name: t('languages.yi') },
  { code: 'yo', name: t('languages.yo') },
  { code: 'za', name: t('languages.za') },
  { code: 'zu', name: t('languages.zu') }
]
